import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: getFieldLabel() }, { name: "구분" }, { name: "교육일" }, { name: "재해형태" }, { name: "교육 실시 인원" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 학교(기관)명
        case 1:
          return func.getContent(value).education_type; // 교육구분
        case 2:
          return func.getContent(value).education_date; // 교육일
        case 3:
          return func.getContent(value).reflected_disaster_type.join(", "); // 재해형태
        case 4:
          return func.comma(func.getContent(value).participants_attended); // 교육실시인원
        case 5:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push("content$body.reflected_disaster_type*%[:default_disaster]%");

    switch (nav.value.searchType) {
      case getFieldLabel():
        returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
        break;
      case "구분":
        returnData.push("content$body.education_type*%[:default_skw]%");
        break;
      case "교육일":
        returnData.push("content$body.education_date*%[:default_skw]%");
        break;
      case "교육 실시 인원":
        returnData.push("content$body.participants_attended*%[:default_skw]%");
        break;
    }

    return returnData;
  },
};
